import { Box } from "@mui/material";
import BrowserCheckMessage from "./BrowserCheckMessage";
import { useEffect, useState } from "react";
import getBrowserName, { browserNames } from "utils/getBrowserName";
import getConnectionQuality from "utils/getConnectionQuality";
import UnstableConnectionModal from "./UnstableConnectionModal";
import UnsupportedBrowserModal from "./UnsupportedBrowserModal";
import LearnerSurveyModal from "./LearnerSurveyModal";
import { useSelector } from "react-redux";


const BrowserCheckMessagePanel = () => {
  const { role, id } = useSelector((state: any) => state.account);

  const wasSurveyShownKey = `wasSurveyShownToLearner_${id}`;
  const wasSurveyShown = sessionStorage.getItem(wasSurveyShownKey) === "true";
  const isLearner = role !== "ROLE_EDUCATOR";
  const [currentBrowserName, setCurrentBrowserName] = useState("Unknown");
  const [isConnectionUnstable, setIsConnectionUnstable] = useState(false);
  const [showUnstableConnectionModal, setShowUnstableConnectionModal] = useState(false);
  const [showUnsupportedBrowserModal, setShowUnsupportedBrowserModal] = useState(false);
  const [showLearnerSurveyModal, setShowLearnerSurveyModal] = useState(isLearner && !wasSurveyShown);

  useEffect(() => {
    const setBrowserName = async () => {
      const browserNameResult = await getBrowserName();
      setCurrentBrowserName(browserNameResult);
    }

    setBrowserName();
  }, []);

  useEffect(() => {
    const checkConnectionQuality = async () => {
      const connectionQuality = await getConnectionQuality();

      if (connectionQuality) {
        if (connectionQuality.downlink < 2 || connectionQuality.downloadSpeedStatus !== "ok" || connectionQuality.estimatedLatency > 300 || connectionQuality.isWeakConnectionType) {
          setIsConnectionUnstable(true);
        }
      }
    }

    checkConnectionQuality();
  }, [])

  const isBrowserNotSupported = currentBrowserName !== browserNames.googleChrome;
  
  return (
    <>
      <UnstableConnectionModal
        isOpen={showUnstableConnectionModal}
        onClose={() => setShowUnstableConnectionModal(false)}
      />

      <UnsupportedBrowserModal
        isOpen={showUnsupportedBrowserModal}
        onClose={() => setShowUnsupportedBrowserModal(false)}
      />

      <LearnerSurveyModal
        isOpen={showLearnerSurveyModal}
        onClose={() => {
          setShowLearnerSurveyModal(false)
          sessionStorage.setItem(wasSurveyShownKey, "true");
        }}
      />

      <Box sx={{ marginTop: "10px", width: "full" }}>
        {
          isBrowserNotSupported && (
            <>
              <BrowserCheckMessage
                message={`You're using ${currentBrowserName} which is unsupported. `}
                severity="error"
                onLearnMoreClick={() => {
                  setShowUnsupportedBrowserModal(true);
                  setShowUnstableConnectionModal(false);
                }}
              />
            </>
          )
        }

        {
          isConnectionUnstable && (
            <>
              <BrowserCheckMessage
                message="Your internet connection is unstable"
                severity="error"
                onLearnMoreClick={() => {
                  setShowUnstableConnectionModal(true);
                  setShowUnsupportedBrowserModal(false);
                }}
              />
            </>
          )
        }

        {
          isLearner && (
            <>
              <BrowserCheckMessage
                message="Please complete this survey by May 29."
                severity="error"
                customLinkLabel="Click Here"
                hideIcon={true}
                onLearnMoreClick={() => setShowLearnerSurveyModal(true)}
              />
            </>
          )
        }
      </Box>
    </>
  )
};

export default BrowserCheckMessagePanel;